const features = [
  { title: "Adaptive Learning", body: "Lessons respond to what the learner understands and what needs reinforcement." },
  { title: "Decision Practice", body: "Realistic choices and scenarios turn concepts into judgment." },
  { title: "Evidence-Based Progress", body: "Independent assessments track what a learner can actually demonstrate." },
  { title: "Parent Visibility", body: "Parents can follow progress without turning learning into micromanagement." },
];

const PracticalSkillsSection = () => (
  <section className="relative py-14 sm:py-16">
    <div className="container mx-auto px-6 max-w-6xl">
      <div className="relative rounded-3xl p-[1px] bg-gradient-to-r from-indigo-500/30 via-violet-500/20 to-cyan-400/30">
        <div className="relative rounded-3xl bg-[#0e0d24]/80 backdrop-blur-xl p-6 sm:p-8">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5">
            <div>
              <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-white/55 mb-3">
                <span className="h-1.5 w-1.5 rounded-full bg-white/50" />
                Built for lasting understanding
              </div>
              <h3 className="font-heading text-xl sm:text-2xl text-white leading-[1.15] max-w-xl">
                A focused path for practical decisions across money, economics, business, and entrepreneurship.
              </h3>
            </div>
          </div>

          <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {features.map((feature) => (
              <div key={feature.title} className="border-l border-white/15 pl-4">
                <div className="font-heading text-base text-white">{feature.title}</div>
                <div className="mt-2 text-sm leading-relaxed text-white/60">{feature.body}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default PracticalSkillsSection;